import React from "react";
import {Field} from "react-final-form";
import RadioButton from "./RadioBig";
import {Trans} from "../utils/i18n";
import Checkbox from "./Checkbox";

export default function ShippingBox({ values, form,  }) {
    return (
        <div className={'b2x-shadow-md p-9 flex flex-col items-center'}>
            <div className={'flex items-center gap-6 w-2/3'}>
                <svg width="127" height="115" viewBox="0 0 127 115" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50.3142 0L127 16.6914L77.3496 44.391L0 27.6667L50.3142 0Z" fill="#E8E8E8"/>
                    <path d="M0 27.6667L77.3496 44.391L77.3499 114.424L0.000300759 97.1438L0 27.6667Z" fill="#D9D9D9"/>
                    <path d="M77.3496 44.391L126.999 16.6914V86.2015L77.3499 114.424L77.3496 44.391Z" fill="#BDBDBD"/>
                    <path d="M31.8809 34.7222L40.7656 36.5514V62.1604L31.8809 60.3312V34.7222Z" fill="#AEAEAE"/>
                    <path d="M81.0083 6.50007L89.8931 8.32929L40.7656 36.5514L31.8809 34.7222L81.0083 6.50007Z"
                          fill="#AEAEAE"/>
                </svg>
                <div className={'flex-1'}>
                    <p>[Shipping Box]</p>
                    <p>
                        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod
                        tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
                        vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,
                        no sea takimata sanctus es
                    </p>
                </div>
            </div>
            <div className={'mt-9'}>
                <Field
                    name={'shipping_box'}
                    type={'checkbox'}
                    component={Checkbox}
                    validate={value => (value ? undefined : <Trans i18nKey="requestTypeSelect.required">Required</Trans>)}
                    field={{
                        label: 'I need a shipping box for my [product]',
                        name: 'shipping_box',
                    }}
                />

            </div>
        </div>
    );
}
